export default __webpack_public_path__ + "static/media/cat17.d5ee0e37.png";